import React, { Component } from 'react';
import FileList from './FileList';
import ls from 'local-storage';
import { Dropdown, Button, ButtonGroup, Form, InputGroup, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import $ from 'jquery';


export default class TemplateEditor extends Component {
    static displayName = TemplateEditor.name;
    _isMounted = false;
    editor = null;
    iconPickerOptions = null;
    sortableListOptions = null;


    constructor(props) {
        super(props);
        this.frmEditRef = React.createRef();
        this.publicAccessCheckChange = this.publicAccessCheckChange.bind(this);
        this.onChangeAllowIndex = this.onChangeAllowIndex.bind(this);

        this.state = {
            addDocFilter: "document", allowIndex: true, isAddingUrl: false, teamOwnerId: ls.get('currentTeam') || props.currentTeam, IsPremium:true,
            addEdit: false, message: "", publicAccess: true, templateId: this.props.match.params.id, templateName: null, templateContent: null,
            documentIdsInList: [], newDocs: []
        };
        console.log(props.currentTeam);
        //this.editorAdd = this.editorAdd.bind(this);
        this.onChangeTempName = this.onChangeTempName.bind(this);
        this.saveTemplate = this.saveTemplate.bind(this);
        //No icons so removed this eventually
        this.iconPickerOptions = {
            searchText: "Buscar...",
            labelHeader: "{0}/{1}"
        };
        // sortable list options
        this.sortableListOptions = {

            placeholderCss: {
                'background-color': "#cccccc"
            }
        };

    }

    getTemplate = async (id) => {
        //e.preventDefault();
        if (id !== '0') {
            const resp = await fetch('api/template/gettemplate?templateid=' + id, {
                method: 'GET',
                credentials: 'same-origin'
            }
            );
            if (resp.status === 200) {

                try {
                    const jdata = await resp.json();

                    if (jdata.teamId !== this.state.teamOwnerId) {
                        //Go back to collection if team changes
                        this.props.history.push('/lists');
                    }
                    let docIds = [];
                    this.getDocumentIdsRecursive(!!jdata.content ? JSON.parse(jdata.content) : [], docIds);
                    let documentsArray = !!jdata.content ? JSON.parse(jdata.content) : [];
                    this.bindOnRemoveCallbackRecursive(documentsArray);

                    this.setState({
                        allowIndex: jdata.allowIndex, IsPremium: jdata.isPremium, publicAccess: jdata.publicAccess,
                        templateId: jdata.id, templateName: jdata.name, documentIdsInList: docIds, templateContent: documentsArray
                    })
                    //console.log(documentsArray);
                    //console.log(JSON.stringify(documentsArray));
                    this.editor.setData(!!jdata.content ? documentsArray : null);
                    $(".pl-0").show();

                } catch (e) {

                    this.setState({ message: '500: Check console' })
                }
            }
            else if (resp.status === 401) {
                this.setState({ doc: '401: Not Authorized' })
            }
            else {
                this.setState({ message: 'There was a problem, please try again later.' });
            }
        }
        else {
            //New template, no longer passing full team json so check for premium
            console.log(this.state.teamOwnerId);
            const resp = await fetch('api/team/getteam?teamid=' + encodeURIComponent(this.state.teamOwnerId), {
                method: 'GET',
                credentials: 'same-origin'
            }
            );

            if (resp.status === 200) {

                try {
                    const jdata = await resp.json();
                    console.log(jdata);
                    this.setState({IsPremium :jdata.team.branding.premium})
                }
                catch{ this.setState({ IsPremium: false }) }
            }
            else this.setState({ IsPremium: false })
        }
    }
    getDocumentIdsRecursive = (documentsArray, idsArray) => {
        for (var i = 0; i < documentsArray.length; i++) {
            idsArray.push(documentsArray[i].href);
            if (documentsArray[i].children) {
                this.getDocumentIdsRecursive(documentsArray[i].children, idsArray);
            }
        }
    }
    getDocumenChildIdsRecursive = (documentsArray, id, idsArray) => {
        if (documentsArray) {
            for (var i = 0; i < documentsArray.length; i++) {
                if (documentsArray[i].href == id && documentsArray[i].children) {
                    this.getDocumentIdsRecursive(documentsArray[i].children, idsArray)
                }
                else if (documentsArray[i].children) {
                    this.getDocumenChildIdsRecursive(documentsArray[i].children, id, idsArray);
                }
            }
        }
    }

    bindOnRemoveCallbackRecursive = (documentsArray) => {
        for (var i = 0; i < documentsArray.length; i++) {
            documentsArray[i].onRemoveItemCallback = this.onRemoveItemCallback;
            if (documentsArray[i].children) {
                this.bindOnRemoveCallbackRecursive(documentsArray[i].children);
            }
        }
    }
    onRemoveItemCallback = ({ href }) => {

        const docIds = [];
        var _newDocs = this.state.newDocs;
        this.setState({ newDocs: _newDocs.filter(item => item.href !== href) });
        docIds.push(href);

        this.getDocumenChildIdsRecursive(this.state.templateContent, href, docIds);
        //console.log(docIds);
        var _documentIdsInList = this.state.documentIdsInList.filter(item => !docIds.includes(item));
        const documents = this.state.templateContent;
        var newdocuments = documents.filter(item => item.href !== href);
   
        this.setState({ documentIdsInList: _documentIdsInList, templateContent: newdocuments });
        //this.editor.setData(newdocuments);
        this.FileList.filterListData("");
    }
    updateDocumentName = ({ href, text }) => {
        const documents = this.state.templateContent;
        if (text && text.trim().length) {
            this.updateDocumentNameInDocTreeRecursive({ documentsArray: documents, href, text });
        }
        this.setState({ templateContent: documents })
        this.editor.setData(documents);
        $(".pl-0").show();
    }
    updateDocumentNameInDocTreeRecursive({ documentsArray, href, text }) {
        if (documentsArray) {
            for (var i = 0; i < documentsArray.length; i++) {
                if (documentsArray[i].href == href) {
                    documentsArray[i].text = text
                }
                else if (documentsArray[i].children) {
                    this.updateDocumentNameInDocTreeRecursive({ documentsArray: documentsArray[i].children, href, text })
                }
            }
        }
    }
    openFileModal = (e) => {
        e.preventDefault();
        $('#fileModal').modal();

        //Uncheck everything
        $("#fileModal .form-check-input").each(function () {
            $(this).prop("checked", false);
        });
        //Show everything
        $("#fileModal .file-list").show();

        //Hide things already selected
        var li = $("#myEditor li");
        for (var i = 0; i < li.length; i++) {
            var l = null;
            //For some insane reason I had to use eval to scope jquery???
            //There goes an hour of my life and my last hair - thanks React!
            eval("l = $(li[i]).data('href');");
            if (l) {
                try {
                    $("#" + l, $("#fileModal")).each(function () {
                        $(this).closest("tr").hide();
                    });
                } catch (e) { }
            }
        }

    }
    editorAdd = (data) => {
      
        this.bindOnRemoveCallbackRecursive(data);
        var i;
        var _newDocs = this.state.newDocs;
        for (i = 0; i < data.length; i++) {
            this.editor.addData(data[i]);
            _newDocs.push(data[i]);

        }
        let _documentIdsInList = this.state.documentIdsInList;
        _documentIdsInList.push(...(data.map(file => file.href)));
        this.setState({ documentIdsInList: _documentIdsInList, newDocs: _newDocs });

    }

    addTemplate = () => {
        this.setState({ addEdit: !this.state.addEdit });
    }
    onEditDocNameFormSubmit = (e) => {

        e.preventDefault();
        e.stopPropagation();
        const formvalues = $(e.target).serializeArray();
        let object = {};
        formvalues.forEach(function (obj, index) {
            object[obj.name] = obj.value;
        });

        try {
            $("#frmEdit").appendTo($("#frmEditWrapper"));
        } catch (e) {
        }
        this.editor.resetForm();

        this.updateDocumentName(object);
    }

    onEditDocNameInputBlur = (e) => {
        e.preventDefault();
        e.stopPropagation();
        //debugger
        const formvalues = $(e.target).parents("#frmEdit").eq(0).serializeArray();
        let object = {};
        formvalues.forEach(function (obj, index) {
            object[obj.name] = obj.value;
        });

        try {
            $("#frmEdit").appendTo($("#frmEditWrapper"));
        } catch (e) {
        }
        this.editor.resetForm();

        this.updateDocumentName(object);
    }
    resetDocEditForm = (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            $("#frmEdit").appendTo($("#frmEditWrapper"));
        } catch (e) {
        }
        this.editor.resetForm();
    }


    componentDidMount() {
        this._isMounted = true;

        this.editor = new window.MenuEditor('myEditor', {
            listOptions: this.sortableListOptions
        });

        this.editor.setForm($('#frmEdit'));
        this.editor.parentEditor = this;
        this.editor.onChange = this.onChangeData;
        //temporary 

        if (this.state.templateId) {

            (async () => { this.getTemplate(this.state.templateId) })();
        }

    }

    async componentDidUpdate(prevProps) {

        if (this.props.currentTeam !== prevProps.currentTeam) {
        
            await this.setState({ msg: "You switched to a new team. Taking you to their Lists..." });
            setTimeout(null, 1);
            this.props.history.push('/lists');
        }

    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleScriptCreate() {
        this.setState({
            scriptLoaded: false
        })
    }
    handleScriptError() {
        this.setState({
            scriptError: true
        })
    }
    handleScriptLoad() {
        this.setState({
            scriptLoaded: true
        });

    }

    onChangeData(e) {

        let jdata = JSON.parse(e.getString());

        let docIds = [];
        e.parentEditor.getDocumentIdsRecursive(jdata, docIds);
        let documentsArray = jdata;
        e.parentEditor.bindOnRemoveCallbackRecursive(documentsArray);

        e.parentEditor.setState({ documentIdsInList: docIds, templateContent: documentsArray })
    }
    onChangeAllowIndex(e) {

        this.setState({
            allowIndex: e.target.checked
        });

    }
    onChangeTempName(e) {
        this.setState({
            templateName: e.target.value
        });
    }
    onAddDocSelect(eventKey, e) {
        if (eventKey === 'URL') {
            this.setState({ isAddingUrl: true }, () => { this.openFileModal(e) });
        }
        else {
            this.setState({ isAddingUrl: false, addDocFilter: eventKey }, () => { this.openFileModal(e) });
        }

    }

    saveTemplate = async (e, view) => {
        e.preventDefault();

        if (this.state.templateName === null || this.state.templateName === "") {
            this.setState({ message: "You must enter a name for the collection." });
            return;
        }
        var viewUrl = "";
        await this.setState({ message: "Working..." });
        var data = {
            AllowIndex: this.state.allowIndex, Id: this.state.templateId, Name: this.state.templateName,
            TeamId: this.state.teamOwnerId, TemplateNodes: this.editor.getString(),
            NewDocs: JSON.stringify(this.state.newDocs),
            PublicAccess: this.state.publicAccess
        }
      
        await this.setState({ message: "Saving..." });
        const resp = await fetch('api/template/savetemplate', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        );
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();

                //await   this.setState({ templateId: jdata.templateRetId, tempList: jdata, message: jdata.statusText, newDocs: [] });
                this.setState({ message: jdata.statusText });
                this.setState({ templateId: jdata.templateRetId, newDocs: [] });
                viewUrl = jdata.viewUrl;

            } catch (e) {
                //console.log(resp.statusText);
                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ doc: '401: Not Authorized' })
        }
        else if (resp.status === 400) {
            console.log('400');
            const jdata = await resp.json();
            this.setState({ message: jdata.statusText });
        }
        else {

            this.setState({ message: 'There was a problem, please try again later.' });
        }
        if (view) {

            window.open(viewUrl, '_blank');
        }
    }


    publicAccessCheckChange = async (e) => {
        await this.setState({ publicAccess: e.target.checked });
    }

    render() {
        //console.log("templateId: "+this.state.templateId);
        const isPremium = this.state.IsPremium;
        const premMsg = !isPremium ? (<div className="row ">
            <div className="col  mb20 ml-3 alert alert-danger">
                Only publicly viewable content is allowed for unpaid Teams
            </div>
        </div>) : "";


        return (
            <div>
                <h2>{
                    (this.state.templateId !== 0) ? ("Edit Collection") : ("Add Collection")
                }</h2>

                <div id="frmEditWrapper" className="d-none">
                    <Form className="pt-2" id="frmEdit" onSubmit={(e) => this.onEditDocNameFormSubmit(e)} ref={this.frmEditRef}>
                        <InputGroup>
                            <FormControl
                                className="item-menu"
                                size="sm"
                                type="text"
                                name="text"
                                placeholder="Enter document name"
                                aria-label="Enter document name"
                                onBlurCapture={(e) => this.onEditDocNameInputBlur(e)}
                            />
                            <Form.Control size="sm" type="hidden" className="item-menu" name="href" />

                        </InputGroup>
                        <Form.Text className="text-muted form-text mt-0 mb-2 ml-1 form-text">
                            Edit document name. Changes will only apply if you save the list using the save button at the bottom
                                 </Form.Text>

                    </Form>

                </div>
                <FileList ref={instance => { this.FileList = instance; }} fileFilter={this.state.addDocFilter} isUrl={this.state.isAddingUrl} editorAdd={this.editorAdd} documentIdsInList={this.state.documentIdsInList} />


                <div className="" id="tempeditor">
                    <div className="row">
                        <div className="col mb20">
                            <input type="text" name="name" placeholder="Untitled" value={this.state.templateName} className="form-control-lg form-control" onChange={this.onChangeTempName} />
                        </div>
                    </div>
                    {premMsg}
                    <div className="row ">
                        <div className="col  mb20 ml-3 custom-control custom-checkbox">
                            <input type="checkbox" id="access" className="custom-control-input ml-0" disabled={!isPremium} checked={this.state.publicAccess} onChange={(e) => this.publicAccessCheckChange(e)} />
                            <label className="custom-control-label" htmlFor="access">Public Access (vs. Team Only) </label>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col  mb20 ml-3 custom-control custom-checkbox">
                            <input type="checkbox" id="index" className="custom-control-input ml-0" disabled={!isPremium} checked={this.state.allowIndex} onChange={(e) => this.onChangeAllowIndex(e)} />
                            <label className="custom-control-label" for="index">Allow Search Engine Indexing On This Collection (if public)</label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col mb-3">
                            <ul id="myEditor" className="sortableLists list-group"></ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-3">
                            <div className="btn-group">
                                <Dropdown as={ButtonGroup} onSelect={(eventKey, e) => this.onAddDocSelect(eventKey, e)}>
                                   
                                    <Button variant="secondary" onClick={(e) => this.onAddDocSelect("Document", e)}> Add Document </Button>
                                    <Dropdown.Toggle variant="secondary" id="dropdown-basic" >
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>

                                        <Dropdown.Item as="button" eventKey="Presentation">Add Presentation</Dropdown.Item>
                                        <Dropdown.Item as="button" eventKey="Spreadsheet">Add Spreadsheet</Dropdown.Item>
                                        <Dropdown.Item as="button" eventKey="URL">Add URL</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>

                                <button onClick={(e) => this.saveTemplate(e, false)} className="btn btn-primary" >Save & Continue</button>
                                <button onClick={(e) => this.saveTemplate(e, true)} className="btn btn-primary " >Save & View</button>


                            </div>
                            <Link to="/lists" className="btn btn-light " style={{ float: 'right' }}>  Back </Link>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col mb-3">
                            <div className="alert alert-info mt20" dangerouslySetInnerHTML={{ __html: this.state.message }}></div>
                        </div>
                    </div>
                    <div id="viewDoc" className="modal" tabIndex="-1" role="dialog">
                        <div className="modal-dialog  modal-lg modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


